export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').trim();
export const HAS_API = API_BASE_URL.length > 0;

export const WHATSAPP_NUMBER = (process.env.REACT_APP_WHATSAPP_NUMBER || '5519974085161').replace(/\D/g, '');

export const GA4_ID = (process.env.REACT_APP_GA4_ID || '').trim();

